import {
  ApplicationConfig,
  isDevMode,
  provideBrowserGlobalErrorListeners,
  provideAppInitializer,
  inject,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { provideTransloco, TranslocoService, getBrowserLang } from '@jsverse/transloco';

import { routes } from './app.routes';
import { getFirebaseApp } from './core/firebase';
import { ThemeService } from './core/theme.service';
import { TranslocoHttpLoader } from '../transloco-loader';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(),
    provideTransloco({
      config: {
        availableLangs: ['en', 'fr'],
        defaultLang: 'fr',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    provideAppInitializer(() => { getFirebaseApp(); }),
    provideAppInitializer(() => { inject(ThemeService); }),
    // OrgContext.init() is intentionally NOT a bootstrap initializer: it runs a
    // chain of Firestore reads that would otherwise block first paint for every
    // route. The `redirectUnauthorizedTo` auth guard runs init() (guarded
    // against rejection) once a session is established, before any
    // authenticated route activates, so org context is still ready in time.
    provideAppInitializer(() => {
      const translate = inject(TranslocoService);
      const savedLang = localStorage.getItem('lang');

      if (savedLang && ['en', 'fr'].includes(savedLang)) {
        translate.setActiveLang(savedLang);
        return;
      }

      // Check root domain cookie
      try {
        const cookies = document.cookie.split(';');
        for (const c of cookies) {
          const t = c.trim();
          if (t.startsWith('crewdle_lang=')) {
            const v = decodeURIComponent(t.substring('crewdle_lang='.length));
            if (v === 'en' || v === 'fr') {
              translate.setActiveLang(v);
              localStorage.setItem('lang', v);
              return;
            }
          }
        }
      } catch {}

      const browserLang = getBrowserLang();
      if (browserLang?.match(/en|fr/)) {
        translate.setActiveLang(browserLang);
      }
    }),
  ],
};
